import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { api_routes } from '@app/consts';
import { catchError, map } from 'rxjs/operators';
import { BenefitsPlanSubmit, BenefitsPlanVerbose, BenefitsRateType, BenefitsWaitPeriodLengthUnit } from '../models/benefits-plan.model';
import { EnvironmentService } from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class BenefitsPlansService {

  constructor(private http: HttpClient, private envService: EnvironmentService) {}

  getPlans(sort?: string, filter?: string, take?: string, skip?: number, asOf?: string,): Observable<any> {
    let params = new HttpParams();
    sort ? params = params.append('sort', sort) : null;
    filter ? params = params.append('filter', filter) : null;
    asOf ? params = params.append('asOf', asOf) : null;
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}`, {
      headers: headers,
      params: params
    })
    .pipe(
      catchError(err => throwError(err)),
      map(res => {
        let data = {
          data: res.data,
          total: res.total
        }

        return data;
      })
    );
  }

  deletePlan(id: string): Observable<any> {
    return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${id}`, {
      headers: headers
    });
  }

  getPlan(id: string): Observable<BenefitsPlanVerbose> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${id}`, {
      headers: headers
    });
  }

  updatePlan(employeePlan: BenefitsPlanSubmit): Observable<any> {
    return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${employeePlan.id}`, employeePlan, {
      headers: headers
    });
  }

  createPlan(employeePlan: BenefitsPlanSubmit): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}`, employeePlan, {
      headers: headers
    });
  }

  getRateTypes(): Observable<BenefitsRateType[]> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.RATE_TYPES}`, {
      headers: headers
    })
  }

  getWaitPeriodLengthUnits(): Observable<BenefitsWaitPeriodLengthUnit[]> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.WAIT_PERIOD_LENGTH_UNITS}`, {
      headers: headers
    })
  }


}
